import * as userActions from '../user/actions';
import * as unitedCardReestrActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const unitedCardReestrReducer = (state = initialState, action) => {
    switch (action.type) {
        case unitedCardReestrActions.SET_UNITED_CARD_REESTR_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case unitedCardReestrActions.SET_UNITED_CARD_REESTR_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case unitedCardReestrActions.SET_UNITED_CARD_REESTR:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case unitedCardReestrActions.ABORT_UNITED_CARD_REESTR_REQUEST:
            return initialState;

        case unitedCardReestrActions.CLEAN_UNITED_CARD_REESTR:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/unitedCardReestr/reducer.js